export default "__VITE_ASSET__FKY4liJx__"